import React from 'react';
import { cn } from '../cn';
import { Typography } from '../Typography/Typography';

type Props = {
  /**
   * The current character count.
   */
  count: number,
  /**
   * Sets the maximum character count.
   */
  max: number,
}

export default function TextfieldCharacterCount({ count = 0, max = 0 }: Props): JSX.Element {
  return (
    <div className='flex justify-end'>
      <Typography tag='p' className={cn([
        'pt-1',
        'text-xs',
        max < count ? 'text-error font-medium' : 'text-text',
      ])}>{`${count} / ${max}`}</Typography>
    </div>
  );
}
